import React from 'react';

/** Barre de recherche + filtres + sélecteur de vue extraite de BuildingVehiculesTab.tsx. */

interface VehiculesFiltersBarProps {
  searchQuery: string;
  onSearchChange: (v: string) => void;
  filterStatut: string;
  onFilterStatutChange: (v: string) => void;
  viewMode: 'compact' | 'detailed';
  onViewModeChange: (v: 'compact' | 'detailed') => void;
}

const VehiculesFiltersBar: React.FC<VehiculesFiltersBarProps> = ({
  searchQuery,
  onSearchChange,
  filterStatut,
  onFilterStatutChange,
  viewMode,
  onViewModeChange,
}) => (
  <div className="space-y-3">
    <div className="flex items-center gap-2">
      <div className="relative flex-1">
        <input
          type="text"
          placeholder="Rechercher par nom ou type..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full px-4 py-2 pl-10 bg-zinc-800 border border-zinc-700 rounded-lg text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent text-sm"
        />
        <svg
          className="absolute left-3 top-2.5 w-4 h-4 text-zinc-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </div>
      <select
        value={filterStatut}
        onChange={(e) => onFilterStatutChange(e.target.value)}
        className="px-3 py-2 bg-zinc-800 border border-zinc-700 rounded-lg text-white text-sm focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent"
      >
        <option value="all">Tous les statuts</option>
        <option value="disponible">Disponible</option>
        <option value="en_mission">En mission</option>
        <option value="en_maintenance">En maintenance</option>
        <option value="panne">Panne</option>
      </select>
      <div
        className="flex shrink-0 overflow-hidden rounded-lg border border-zinc-600"
        role="group"
        aria-label="Mode d’affichage liste véhicules"
      >
        <button
          type="button"
          onClick={() => onViewModeChange('compact')}
          title="Vue compacte"
          className={`flex items-center gap-2 px-3 py-2 text-sm font-medium ${
            viewMode === 'compact'
              ? 'bg-blue-600 text-white'
              : 'bg-zinc-800 text-zinc-300 hover:bg-zinc-700'
          }`}
        >
          <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden>
            <path d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z" />
          </svg>
          <span className="hidden sm:inline">Compacte</span>
        </button>
        <button
          type="button"
          onClick={() => onViewModeChange('detailed')}
          title="Vue détaillée"
          className={`flex items-center gap-2 border-l border-zinc-600 px-3 py-2 text-sm font-medium ${
            viewMode === 'detailed'
              ? 'bg-blue-600 text-white'
              : 'bg-zinc-800 text-zinc-300 hover:bg-zinc-700'
          }`}
        >
          <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden>
            <path d="M4 6h16v2H4V6zm0 5h16v2H4v-2zm0 5h16v2H4v-2z" />
          </svg>
          <span className="hidden sm:inline">Détaillée</span>
        </button>
      </div>
    </div>
  </div>
);

export default VehiculesFiltersBar;

